<template>
  <div class="patrol-panel">
    <ioc-form
      ref="form"
      v-model="ruleForm"
      :option="optionForm"
      @submit="submitForm"
      @reset-change="handleClose"
    >
      <!-- start @description: 表单-黑名单组按钮 !-->
      <template slot-scope="scope" slot="blackGroup">
        <div class="rel">
          <el-tooltip class="item" effect="dark" :content="ruleForm.blackGroup || $t('carPatrol.label.nodata')" placement="bottom">
            <el-input disabled v-model="ruleForm.blackGroup" class="abs group-list">{{scope}}</el-input>
          </el-tooltip>
          <a href="javascript:;" class="abs pl10 pr5 mr20 r0" @click="openBlackGroup">
            <span>{{$t('carPatrol.label.select')}}</span>
          </a>
        </div>
      </template>
      <!-- start @description: 表单-布控时段按钮 !-->
      <template slot-scope="scope" slot="timeList">
        <div class="rel">
          <el-input disabled v-model="ruleForm.timeSlotText" class="abs">{{scope}}</el-input>
          <a href="javascript:;" class="abs pl10 pr5 mr20 r0" @click="openTimeList">
            <span>{{$t('carPatrol.label.select')}}</span>
          </a>
        </div>
      </template>
    </ioc-form>
    <!-- 布控时段选择弹窗 -->
    <el-dialog v-dialogDrag :title="$t('carPatrol.title.ControlTimeSelect')" :visible.sync="controlWindowShow" :modal="false" width="1200px">
      <app-calendar-range
        :isNeedFooter="true"
        @close="close"
        ref="appCalendarRange"
        @getDate="getDate"
      />
    </el-dialog>
    <!-- 黑名单组件 -->
    <black-group ref="blackgroup" @selectBlackList="selectBlackList"></black-group>
  </div>
</template>
<script>
import { optionForm } from '../options/createColumn'
import { Data, Log,Dates } from '$utils'
import { setTimeout } from 'timers';

export default {
  components: {
    // 黑名单列表
    BlackGroup: () => import('./BlackGroup'),
    // 日期范围面板组件
    AppCalendarRange: () => import('@src/components/business/app-calendar-range')
  },
  data() {
    return {
      formData: {},
      // 创建/修改布控的数据
      ruleForm: {
        // 布控名称
        controlName: '',
        // 黑名单组
        blackGroup: '',
        // 布控时段时间组件
        timeList: [],
        // 布控开始时间
        startDate: '',
        // 布控结束时间
        endDate: '',
        // 布控级别
        alarmLevel: 1,
        // 布控时间段回显
        timeSlotText: '',
        // 黑名单组
        groupList: []
      },
      // 表单的配置
      optionForm: {
        //让自带的提交和清空按钮隐藏
        submitPosition: 'center',
        size: 'mini',
        submitText: '',
        emptyText: this.$t('carPatrol.button.cancel'),
        labelPosition: 'right',
        span: 12,
        clearable: true,
        menuBtn: true,
        column: optionForm()
      },
      controlWindowShow: false
    }
  },
  mounted() {
      this.optionForm.submitText = this.$t('carPatrol.button.confirm')
      this.optionForm.emptyText = this.$t('carPatrol.button.cancel')
  },
  methods: {
    // 拿到子组件回传的日期段
    getDate(val) {
      console.log('outer>>>>>>', val)
      if(val.dates && val.dates.length){
        this.ruleForm.startDate = Dates.format(val.dates[0],'yyyy-MM-dd');
        this.ruleForm.endDate = Dates.format(val.dates[1],'yyyy-MM-dd');
        this.ruleForm.timeSlotText = Dates.format(val.dates[0],'yyyy-MM-dd') + this.$t('carPatrol.label.to') + Dates.format(val.dates[1],'yyyy-MM-dd')
        this.ruleForm.timeList = val.resData;
      }
    },
    loadData(data) {
      console.log('传递过来的参数', data)
      this.formData = data
      this.$nextTick(() => {
        this.ruleForm.startDate = data.startDate
        this.ruleForm.endDate = data.endDate
        this.ruleForm.timeSlotText = data.startDate + this.$t('carPatrol.label.to') + data.endDate
        this.ruleForm.timeList = data.timeList
        this.ruleForm.controlName = data.name
        this.ruleForm.alarmLevel = data.alarmLevel
        console.log('this.ruleForm.groupList----------------------->', this.ruleForm)
        let blackGroup = []
        data.groupList.forEach(item => {
          this.ruleForm.groupList.push({
            repositoriesCode: item.repositoriesCode
          })
          blackGroup.push(item.repositoriesName)
        })
        console.log('blackGroup----------->', blackGroup)
        this.ruleForm.blackGroup = blackGroup.join(',')
      })
    },
    // 选择黑名单组
    selectBlackList(params) {
      let name = []
      this.ruleForm.groupList.length = 0
      params.forEach(item => {
        name.push(item.name)
        this.ruleForm.groupList.push({
          repositoriesCode: item.code
        })
      })
      this.ruleForm.blackGroup = name.toString()
    },
    // 打开黑名单组
    openBlackGroup() {
      this.$refs.blackgroup.dialogTableBlackList = true
      this.$refs.blackgroup.getNameListGroup()
    //   if (this.$route.name === 'create') {
    //     this.$refs.blackgroup.getNameListGroup()
    //   } else if (this.$route.name === 'edit') {
    //     this.$refs.blackgroup.setData(this.formData.groupList)
    //     // this.$refs.blackgroup.getNameListGroup(this.formData.groupList)
    //   }
    },
    // 选择布控时间段
    openTimeList() {
      this.controlWindowShow = true
      let dataList = {}
      const timeList = this.formData.timeList;
      if(timeList && timeList.length){
        this.formData.timeList.map(item => {
          item.dayType = item.day
          item.startTime = item.startTime.replace(/\:/g, '') // eslint-disable-line
          item.endTime = item.endTime.replace(/\:/g, '') // eslint-disable-line
          delete item.day
          return item
        })
        this.$nextTick(() => {
          this.$refs.appCalendarRange.setData(this.formData.timeList, [this.formData.startDate, this.formData.endDate])
        })
      }
    },
    /*
     *@name:提交功能
     *@param:{type}
     *@description:
     *@return:
     *@author: zhengff
     *@date: 2019-04-30 18:04:39
     */
    submitForm() {
      this.$emit('submit')
    },
    /*
     *@name:取消-返回到布控列表页面
     *@param:{type}
     *@description:返回到布控列表页面
     *@return:无
     *@author: zhengff
     *@date: 2019-05-02 22:06:00
     */
    handleClose() {
      this.$router.push({
        path: '/view/Index',
        name: 'carPatrol'
      })
    },
    //关闭时间组件
    close() {
      console.log('关闭时间组件----------------------')
      this.controlWindowShow = false
    }
  }
}
</script>

<style lang="scss">
  .patrol-panel {
    .group-list {
      &>input {
        padding-right: 56px;
      }
    }
    .calendar-range .pl30 .el-date-editor{width: 510px !important;}
  }
</style>
